module.exports = __webpack_public_path__ + "img/autopay2.c31f4562.svg";